var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.active,
            callback: function ($$v) {
              _vm.active = $$v
            },
            expression: "active",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "Common", name: "common" } },
            [_c("view-status-tab", { attrs: { model: _vm.model } })],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "Messages", name: "messages" } },
            [
              _c("view-messages-tab", {
                attrs: { url: _vm.messageIndexUrl, campaign: _vm.model.id },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }